import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'

interface DeactivationDialogProps {
  open?: boolean
  onClose: () => void
  onDeactivate: () => void
  loading: boolean
}

const DeactivationDialog: React.FC<DeactivationDialogProps> = ({ open, onDeactivate, onClose, loading }) => {
  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={!!open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to deactivate this translations?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          By deactivating this translation you will be removing the translation from the Translation Hub.
          <br /><br />
          If you are concerned how this will affect the site or app, please work with your developers.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button
          color="error"
          autoFocus
          onClick={() => onDeactivate && onDeactivate()}
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : undefined}
        >
          {loading ? 'DEACTIVATING TRANSLATION...' : 'DEACTIVATE TRANSLATION'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeactivationDialog
